import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import { FaCaretLeft, FaCaretRight } from "react-icons/fa"; // Use FaCaretLeft and FaCaretRight
import CtcBM from "../../../assets/images/Sample Gazette with CTC - BM.jpg";
import CtcBI from "../../../assets/images/Sample Gazette with CTC - BI.jpg";
import "./SampleCtc.css"; // Import the CSS file

export default function SampleCtc({ openCtcDialog, setOpenCtcDialog }) {
  const img = [CtcBI, CtcBM];
  const [currentImg, setCurrentImg] = useState(0);

  const handleClose = () => {
    setOpenCtcDialog(false);
  };

  return (
    <Dialog
      open={openCtcDialog}
      onClose={handleClose}
      PaperProps={{
        style: {
          width: "auto",
          height: "auto",
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        },
      }}
    >
      {/* Left Arrow */}
      <div
        onClick={() => {
          if (currentImg !== 0) setCurrentImg(0);
        }}
        className={`warta-arrow-button ${
          currentImg === 0 ? "warta-disabled" : ""
        } warta-arrow-left`}
      >
        <FaCaretLeft />
      </div>

      {/* Image */}
      <img className="sampleCtc" src={img[currentImg]} alt="Sample Gazette" />

      {/* Right Arrow */}
      <div
        onClick={() => {
          if (currentImg !== 1) setCurrentImg(1);
        }}
        className={`warta-arrow-button ${
          currentImg === 1 ? "warta-disabled" : ""
        } warta-arrow-right`}
      >
        <FaCaretRight />
      </div>
    </Dialog>
  );
}
